module.exports = require("express");


//////////////////
// WEBPACK FOOTER
// external "express"
// module id = 40
// module chunks = 0